export default () => {
  document.addEventListener('notShoppableClick', () => {
    // if a Carousel also changes slides within time limit, this is not a true shoppable click
    window.shoppablePaused = true;

    setTimeout(() => {
      window.shoppablePaused = false;
    }, 10);
  });
};
